import { Mixins, Component } from 'vue-property-decorator';
import { ITABLECOLCONF } from '@/types/base.d';
import api from '@/api/exam';
import { ExamTypeEnum } from '@/libs/config';
import { Message } from '@/plugin/message/index';
import pageMixin from '../../../mixins/pageMixin';

@Component
export default class tableMixin extends Mixins(pageMixin) {
  private cList: any = [];

  private column: Array<ITABLECOLCONF> = [{
    label: '试卷名称',
    prop: 'title',
    align: 'left',
    width: '150px',
    tooltip: true,
  }, {
    label: '试卷类型',
    prop: 'type',
    align: 'center',
    width: '120px',
    custom: true,
    tags: [{
      value: 'RANDOM_FIXED',
      type: 'warning',
      label: '随机',
    }, {
      value: 'FixedPapers',
      type: 'success',
      label: '固定',
    }, {
      value: '',
      type: 'danger',
      label: '暂无',
    }],
  }, {
    label: '建议时长(分钟)',
    prop: 'suggestTime',
    align: 'left',
    width: '150px'
  }, {
    label: '及格分',
    prop: 'passingScore',
    align: 'left',
    tooltip: true,
  }, {
    label: '总分',
    prop: 'paperScore',
    align: 'left',
    tooltip: true,
  }, {
    label: '创建时间',
    prop: 'createAt',
    align: 'left',
    width: '150px',
  }, {
    label: '操作',
    custom: true,
    minWidth: '120px',
    align: 'center',
    maxBtn: 1,
    btnList: [
      {
        title: '试题详情',
        name: '/paper/info:chapter',
        icon: 'edit',
        type: 'info',
        callback: this.handelDetail,
        log: {
          name: '试卷管理 - 操作',
          component: 'paper/info/chapter',
        },
      },
      {
        title: '修改',
        name: '/paper/info:update',
        icon: 'edit',
        type: 'info',
        callback: this.handleEdit,
        log: {
          name: '试卷管理 - 修改',
          component: '/paper/info:update',
        },
      },
      {
        title: '删除',
        name: '/paper/info:remove',
        icon: 'trash-o',
        type: 'info',
        callback: this.handleRemove,
        log: {
          name: '试卷管理 - 删除',
          component: '/paper/info:remove',
        },
      },
    ],
  }]

  private loading: boolean = false;

  mounted() {
    this.getData();
  }

  /**
   * @author liuyongchun
   * @desc 获取课程信息列表
   */
  getData(params?: any) {
    this.loading = true;
    this.page.params = params;
    const data = { pageSize: this.page.pageSize, pageNo: this.page.pageNo, ...this.page.params };
    api.pageGetTestPaper(data).then((res: any) => {
      this.cList = res.content;
      this.total = res.totalElements;
      this.loading = false;
    });
  }

  /**
   * @author liuyongchun
   * @desc 查看试卷的题目清单，随机试卷不可查看
   * @param { any } row 行数据
   */
  handelDetail(row: any) {
    console.log(row);
    this.$router.push({ name: 'exam/detail', params: { pid: row.id, type: 'Resource' } });
    // Message.warning('该功能正在建设期间，请稍后再试');
  }

  /**
   * @author liuyongchun
   * @desc 修改试卷
   * @param { any } row 行数据
   */
  handleEdit(row: any) {
    // @ts-ignore
    this.editItem(row);
  }

  /**
   * @author liuyongchun
   * @desc 删除试卷
   * @params { any } row 行数据
   */
  handleRemove(row: any) {
    this.confirm('您确定要删除该试卷吗?', {
      title: '警告',
      loading: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      iconType: 'warning',
    }).then((close: Function) => {
      api.removeTestPaper(row.id).then(() => {
        this.getData();
        close();
        this.$log({
          title: '试卷管理 - 删除 - 确定',
          component: 'trial/manage/bModal',
        });
      }).catch(() => close());
    }).catch(() => this.$log({
      title: '试卷管理 - 删除 - 取消',
      component: 'trial/manage/bModal',
    }));
  }
}
